import React, { useState, useEffect } from 'react';
import * as LuIcons from 'react-icons/lu';
const { LuArrowUp, LuMessageCircle, LuPhone, LuMail, LuPlus, LuX } = LuIcons;
import SafeIcon from './common/SafeIcon';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import { CONTACT_INFO } from '../constants';

const FloatingControls: React.FC = () => {
  const [showScroll, setShowScroll] = useState(false);
  const [expand, setExpand] = useState(false);
  const { t } = useLanguage();

  const whatsappNumber = CONTACT_INFO.phones[0].replace(/\s/g, ''); // Utilise le premier numéro (+237656041309)

  useEffect(() => {
    const checkScroll = () => {
      if (window.scrollY > 400) setShowScroll(true);
      else setShowScroll(false);
    };
    window.addEventListener('scroll', checkScroll);
    return () => window.removeEventListener('scroll', checkScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col gap-3 items-end">
      {/* Menu étendu */}
      <AnimatePresence>
        {expand && (
          <motion.div 
            initial={{ opacity: 0, y: 20, scale: 0.8 }} 
            animate={{ opacity: 1, y: 0, scale: 1 }} 
            exit={{ opacity: 0, y: 20, scale: 0.8 }} 
            className="flex flex-col gap-3 mb-2"
          >
            {/* Email */}
            <a 
              href={`mailto:${CONTACT_INFO.email}`} 
              className="bg-white dark:bg-gray-800 p-3 rounded-full shadow-lg border border-gray-100 dark:border-gray-700 hover:scale-110 transition-transform text-be-france dark:text-be-sky" 
              title={t('email')}
            >
              <SafeIcon icon={LuMail} size={20} />
            </a>

            {/* Téléphone Direct */}
            <a 
              href={`tel:${CONTACT_INFO.phones[1].replace(/\s/g, '')}`} 
              className="bg-white dark:bg-gray-800 p-3 rounded-full shadow-lg border border-gray-100 dark:border-gray-700 hover:scale-110 transition-transform text-be-france dark:text-be-sky" 
              title={t('phone')}
            >
              <SafeIcon icon={LuPhone} size={20} />
            </a>

            {/* WhatsApp Direct */}
            <a 
              href={`https://wa.me/${whatsappNumber.replace('+', '')}`} 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-[#25D366] text-white p-3 rounded-full shadow-lg hover:scale-110 transition-transform" 
              title="WhatsApp"
            >
              <SafeIcon icon={LuMessageCircle} size={20} />
            </a>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Bouton de contrôle principal */}
      <button 
        onClick={() => setExpand(!expand)} 
        className={`p-4 rounded-full shadow-2xl transition-all duration-300 flex items-center justify-center relative ${
          expand 
          ? 'bg-be-darkest text-white rotate-0' 
          : 'bg-gradient-to-br from-be-france to-be-night text-white'
        }`}
      >
        <SafeIcon icon={expand ? LuX : LuPlus} size={24} />
        
        {!expand && (
          <span className="absolute -top-1 -right-1 flex h-4 w-4">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-be-sky opacity-75"></span>
            <span className="relative inline-flex rounded-full h-4 w-4 bg-be-france border-2 border-white dark:border-be-darkest"></span>
          </span>
        )}
      </button>

      {/* Retour en haut */}
      <AnimatePresence>
        {showScroll && (
          <motion.button 
            initial={{ scale: 0 }} 
            animate={{ scale: 1 }} 
            exit={{ scale: 0 }} 
            onClick={scrollToTop} 
            className="bg-white dark:bg-gray-800 text-be-darkest dark:text-white p-3 rounded-lg shadow-lg border border-gray-100 dark:border-gray-700 hover:-translate-y-1 transition-all" 
            title={t('scrollToTop')}
          >
            <SafeIcon icon={LuArrowUp} size={20} />
          </motion.button>
        )}
      </AnimatePresence>
    </div>
  );
};

export default FloatingControls;